module.exports = __webpack_public_path__ + "img/Logo.e568ad46.jpg";